export const facilityName = 'RSKJP Melinda Cardio Vascular Center';
export const facilityId = '2910d2a1-697c-4ce7-9891-b36e3ecf7aa0';